module.exports = __webpack_public_path__ + "static/media/phone-office.fbf86004.svg";